import React, { useRef, useState } from "react";
import "./extra.css";
import { Rating, useMediaQuery } from "@mui/material";
import styled from "@emotion/styled";
import { reviews } from "./constantReview";

const Carousel = () => {
  const StyledRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: "#F29405",
    },
    "& .MuiRating-iconHover": {
      color: "#ff3d47",
    },
  });
  const items = reviews.map((review, index) => (
    <div
      className="rounded-[23px] bg-[#FFF] shadow-customWork px-7 py-6 flex-shrink-0 flex flex-col gap-5 mx-2"
      key={index}
    >
      <div className="flex text-[#F29405]">
        <StyledRating
          size="small"
          sx={{ color: "#F29405" }}
          name="read-only"
          value={review?.rating}
          readOnly
          precision={0.1}
        />{" "}
        <span className="text-sm font-bold">({review?.rating}/5)</span>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-[#000] text-lg font-semibold leading-[105%]">
          {review?.title}
        </p>
        <p className="text-[#000] text-base leading-[159%]">
          {review?.content}
        </p>
      </div>
      <div className="flex flex-col gap-[6px]">
        <p className="text-[18px] font-medium leading-[105%]">
          – {review?.name}
        </p>
        <p className="text-[#9E9E9E] text-[13px] leading-[105%]">
          {review?.date}
        </p>
      </div>
    </div>
  ));

  // Replace with your data
  const containerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);

  const isMobile = useMediaQuery("(max-width:768px)");

  const itemsPerPage = isMobile ? 4 : 6; // 3 items per row * 2 rows
  const totalPages = Math.ceil(items.length / itemsPerPage);

  // Handle dot click to scroll
  const handleDotClick = (pageIndex) => {
    const container = containerRef.current;
    const pageWidth = container.offsetWidth; // Get container width
    const scrollAmount = pageIndex * pageWidth; // Calculate scroll offset
    container.scrollTo({ left: scrollAmount, behavior: "smooth" });
    setCurrentPage(pageIndex); // Update active dot
    // console.log(currentPage, "mm");
  };

  // Handle scroll event to update active dot
  // let newPage = 0;
  const handleScroll = () => {
    const container = containerRef.current;
    const pageWidth = container.offsetWidth;
    console.log(container.scrollLeft, "container.scrollLeft");

    const newPage = Math.round(container.scrollLeft / pageWidth);
    setCurrentPage(newPage);
    // console.log(newPage, "newPage");
  };

  return (
    <div className=" carousel-wrapper">
      <div className="carousel" ref={containerRef} onScroll={handleScroll}>
        {Array(totalPages)
          .fill(0)
          .map((_, pageIndex) => (
            <div
              key={pageIndex}
              className="carousel-page"
              // ref={containerRef}
              //
            >
              {items
                .slice(pageIndex * itemsPerPage, (pageIndex + 1) * itemsPerPage)
                .map((data, index) => (
                  <div key={index} className="carousel-item">
                    <p>{data}</p>
                  </div>
                ))}
            </div>
          ))}
      </div>

      {/* Dots Navigation */}
      <div className="carousel-dots">
        {Array(totalPages)
          .fill(0)
          .map((_, index) => (
            <button
              key={index}
              className={`dot ${currentPage === index ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
      </div>
    </div>
  );
};

export default Carousel;
